import { useEffect, useState } from "react";
import axios from "axios";
import { CONNECTIONS_ENDPOINT } from "../utils/config";

interface ConnectionsResponse {
  availableConnectionNames: string[];
}

export function useConnections(open: boolean) {
  const [names, setNames] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    axios
      .get<ConnectionsResponse>(CONNECTIONS_ENDPOINT)
      .then((res) => setNames(res.data.availableConnectionNames ?? []))
      .catch((err) => {
        console.error("Failed to load connections", err);
        setError("Couldn't load connections. Check the API is reachable.");
      })
      .finally(() => setLoading(false));
  }, [open]);

  return { names, loading, error };
}
